import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/app/assets/css/all.css';
import '../src/app/assets/css/bootstrap.css';

import "../src/app/assets/scss/psb-helpers.scss";

import {Navigate, Route, Routes} from "react-router-dom";
import CustomerDashboard from "./app/cx/CustomerDashboard";
import {useMaterialUIController} from "./context";
import {ThemeProvider} from "@mui/material";
import theme from "./app/assets/theme";
import CustomerCalendar from "./app/cx/CustomerCalendar";
import CustomerWaivers from "./app/cx/CustomerWaivers";
import CustomerWaiver from "./app/cx/CustomerWaiver";
import CustomerCancelEvent from "./app/cx/CustomerCancelEvent";
import CustomerConfirmReservation from "./app/cx/CustomerConfirmReservation";
import CustomerMemberships from "./app/cx/CustomerMemberships";
import CustomerResetPass from "./app/cx/CustomerResetPass";
import CustomerProfile from "./app/cx/CustomerProfile";
import CustomerPurchases from "./app/cx/CustomerPurchases";
import CustomerViewEvent from "./app/cx/event/CustomerViewEvent";
import CustomerViewCart from "./app/cx/CustomerViewCart";
import CheckoutPage from "./app/CheckoutPage";
import CheckoutFinal from "./app/cx/CheckoutFinal";
import {Inventory, Logout} from "@mui/icons-material";
import CustomerStore from "./app/cx/CustomerStore";
import CustomerVisits from "./app/cx/CustomerVisits";
import CustomerGiftCards from "./app/cx/CustomerGiftCards";
import CustomerTransferGiftCard from "./app/cx/CustomerTransferGiftCard";
import {useContext, useEffect, useState} from "react";
import {UserContext} from "./lib/UserProvider";
import CustomerViewEventWaiver from "./app/cx/event/CustomerViewEventWaiver";
import TermsOfService from "./app/cx/TermsOfService";
import Privacy from "./app/cx/Privacy";
import Newsletter from "./app/cx/NewsLetter";
import CustomerLoginPage from "./app/cx/CustomerLoginPage";
import CustomerViewInventory from "./app/cx/event/CustomerViewInventory";
import ReactGA from "react-ga4";

function App({appMode}) {

  const [userContext, setUserContext] = useContext(UserContext);
  const [authenticated, setAuthenticated] = useState(userContext?.sessionUser?.guid?.length > 0);

  ReactGA.initialize("G-W9H9HSVNG5");

  useEffect(() => {
    setAuthenticated(userContext?.sessionUser?.guid?.length > 0);
  }, [userContext]);

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    miniWindow,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;


  const [newsLetter, setNewsLetter] = useState();
  useEffect(() => {
    setNewsLetter('NEWSLETTER' === appMode)
  }, [appMode])

  return (
    <ThemeProvider theme={theme}>

      <Routes>

        {!newsLetter && <>
          <Route exact path="/" element={<CustomerDashboard/>}/>
          <Route exact path="/cx/login" element={<CustomerLoginPage/>}/>
          <Route exact path="/cx" element={<CustomerDashboard/>}/>
          <Route exact path="/cx/" element={<CustomerDashboard/>}/>

          <Route exact path="/cx/events"
                 element={<CustomerCalendar key={'events'} calendarView={false} parties={false}/>}/>
          <Route exact path="/cx/parties"
                 element={<CustomerCalendar key={'parties'} calendarView={false} parties={true}/>}/>

          <Route exact path="/cx/calendar" element={<CustomerCalendar key={'calendar'} calendarView={true}/>}/>
          <Route exact path="/cx/parties-calendar"
                 element={<CustomerCalendar key={'partiesCalendar'} calendarView={true} parties={true}/>}/>

          <Route exact path="/cx/store" element={<CustomerStore key={'store'} cafeMode={false}/>}/>
          <Route exact path="/cx/cafe" element={<CustomerStore key={'cafe'} cafeMode={true}/>}/>
          <Route exact path="/cx/:guid" element={<CustomerDashboard/>}/>

          <Route exact path="/cx/terms-of-service" element={<TermsOfService/>}/>
          <Route exact path="/cx/privacy" element={<Privacy/>}/>
          <Route exact path="/cx/:guid/event/cancel/:eventGuid/:customerGuid" element={<CustomerCancelEvent/>}/>

          <Route exact path="/cx/event/cancel/:eventGuid/:customerGuid" element={<CustomerCancelEvent/>}/>

          <Route exact path="/cx/:guid/event/waitlist/:reservationGuid/:customerGuid"
                 element={<CustomerConfirmReservation/>}/>

          <Route exact path="/cx/event/waitlist/:reservationGuid/:customerGuid"
                 element={<CustomerConfirmReservation/>}/>

          <Route exact path="/cx/gift-card/:itemId" element={<CustomerTransferGiftCard giftCard={true}/>}/>
          <Route exact path="/cx/gift-item/:itemId" element={<CustomerTransferGiftCard giftItem={true}/>}/>
          <Route exact path="/cx/gift-cards" element={<CustomerGiftCards/>}/>
          <Route exact path="/cx/passes" element={<CustomerMemberships/>}/>
          <Route exact path="/cx/memberships" element={<CustomerMemberships/>}/>
          <Route exact path="/cx/pass/reset/:resetId" element={<CustomerResetPass/>}/>

          <Route exact path="/cx/waivers" element={<CustomerWaivers/>}/>
          <Route exact path="/cx/waiver/:guid" element={<CustomerWaiver/>}/>

          <Route exact path="/cx/my-profile" element={<CustomerProfile/>}/>
          <Route exact path="/cx/my-purchases" element={<CustomerPurchases/>}/>
          <Route exact path="/cx/my-visits" element={<CustomerVisits/>}/>
          <Route exact path="/cx/view-item/:inventoryId" element={<CustomerViewInventory/>}/>
          <Route exact path="/cx/view-invoice/:invoiceGuid" element={<CustomerProfile viewInvoice={true}/>}/>

          <Route exact path="/cx/eventWaiver/:eventId" element={<CustomerViewEventWaiver/>}/>

          <Route exact path="/cx/register/:eventId" element={<CustomerViewEvent showDesc={true} embedded={false}/>}/>
          <Route exact path="/cx/event/:eventId" element={<CustomerViewEvent/>}/>
          <Route exact path="/cx/cart" element={<CustomerViewCart/>}/>

          <Route exact path="/cx/checkout" element={<CheckoutPage/>}/>
          <Route exact path="/cx/checkout/success/intent/:paymentIntentId" element={<CheckoutFinal/>}/>
          <Route exact path="/cx/checkout/cancel" element={<CheckoutFinal isCancel={true}/>}/>

          <Route path="/logout" element={<Logout/>}/>

        </>}

        <Route exact path="/cx/newsletter" element={<Newsletter/>}/>

        {newsLetter && <>
          <Route exact path="/cx/newsletter" element={<Newsletter newsletterMode={true}/>}/>
          <Route path="*" element={<Navigate to="/cx/newsletter"/>}/>
        </>
        }
        {!authenticated && <>
          <Route path="*" element={<Navigate to="/cx"/>}/>
        </>}

      </Routes>
    </ThemeProvider>
  );
}

export default App;
